import moment from 'moment'
import { timezoneDate } from 'utils/helpers'

export const groupDataByWorkDate = data => {
  const groupedData = data.reduce((result, item) => {
    const workDate = timezoneDate(item.workDate, null, null, null, 'dddd, MMMM D, YYYY')

    if (result[workDate]) {
      result[workDate].data.push(item)
      result[workDate].totalHours += item.hours
    } else {
      result[workDate] = {
        data: [item],
        totalHours: item.hours
      }
    }

    return result
  }, {})

  // Sort the grouped data by date in ascending order
  const sortedGroupedData = Object.entries(groupedData).sort(
    (a, b) => moment(a[0], 'dddd, MMMM D, YYYY') - moment(b[0], 'dddd, MMMM D, YYYY')
  )

  // Convert the sorted data back to an object with totalHours included
  const sortedDataObject = sortedGroupedData.reduce((result, [key, value]) => {
    result[key] = {
      data: value.data,
      totalHours: value.totalHours
    }
    return result
  }, {})

  return sortedDataObject
}

export const groupDataByUser = data => {
  const groupedData = data.reduce((result, item) => {
    const userName = item.userName

    if (userName !== null) {
      const workDate = timezoneDate(item.workDate, null, null, null, 'dddd, MMMM D, YYYY')

      if (result[userName]) {
        result[userName].data.push(item)
        result[userName].totalHours += item.hours
        if (result[userName].tableData[workDate]) {
          result[userName].tableData[workDate].data.push(item)
          result[userName].tableData[workDate].totalHours += item.hours
        } else {
          result[userName].tableData[workDate] = {
            data: [item],
            totalHours: item.hours
          }
        }
        if (item.billable) {
          result[userName].totalBillableHours += item.hours
          if (item.workType === 'OVERTIME') {
            result[userName].totalBillableOvertimeHours += item.hours
          } else if (item.workType === 'SECOND_SHIFT') {
            result[userName].totalBillableSecondShiftHours += item.hours
          } else if (item.workType === 'THIRD_SHIFT') {
            result[userName].totalBillableThirdShiftHours += item.hours
          } else if (item.workType === 'REGULAR') {
            result[userName].totalBillableRegularHours += item.hours
          }
        } else {
          result[userName].totalNonBillableHours += item.hours
          if (item.workType === 'OVERTIME') {
            result[userName].totalNotBillableOvertimeHours += item.hours
          } else if (item.workType === 'SECOND_SHIFT') {
            result[userName].totalNotBillableSecondShiftHours += item.hours
          } else if (item.workType === 'THIRD_SHIFT') {
            result[userName].totalNotBillableThirdShiftHours += item.hours
          } else if (item.workType === 'REGULAR') {
            result[userName].totalNotBillableRegularHours += item.hours
          }
        }
      } else {
        result[userName] = {
          data: [item],
          totalHours: item.hours,
          totalBillableHours: item.billable ? item.hours : 0,
          totalNonBillableHours: item.billable ? 0 : item.hours,
          billable: item.billable,
          totalBillableOvertimeHours:
            item.billable && item.workType === 'OVERTIME' ? item.hours : 0,
          totalBillableSecondShiftHours:
            item.billable && item.workType === 'SECOND_SHIFT' ? item.hours : 0,
          totalBillableThirdShiftHours:
            item.billable && item.workType === 'THIRD_SHIFT' ? item.hours : 0,
          totalNotBillableOvertimeHours:
            !item.billable && item.workType === 'OVERTIME' ? item.hours : 0,
          totalNotBillableSecondShiftHours:
            !item.billable && item.workType === 'SECOND_SHIFT' ? item.hours : 0,
          totalNotBillableThirdShiftHours:
            !item.billable && item.workType === 'THIRD_SHIFT' ? item.hours : 0,
          totalBillableRegularHours: item.billable && item.workType === 'REGULAR' ? item.hours : 0,
          totalNotBillableRegularHours:
            !item.billable && item.workType === 'REGULAR' ? item.hours : 0,
          tableData: {
            [workDate]: {
              data: [item],
              totalHours: item.hours
            }
          }
        }
      }
    }

    return result
  }, {})

  return groupedData
}
